"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassageBlockType = void 0;
var PassageBlockType;
(function (PassageBlockType) {
    PassageBlockType[PassageBlockType["Paragraph"] = 0] = "Paragraph";
    PassageBlockType[PassageBlockType["Image"] = 1] = "Image";
})(PassageBlockType || (exports.PassageBlockType = PassageBlockType = {}));
